import { render } from "./DialogGetMyticketsError.vue?vue&type=template&id=73ab76df"
import script from "./DialogGetMyticketsError.vue?vue&type=script&lang=js"
export * from "./DialogGetMyticketsError.vue?vue&type=script&lang=js"
script.render = render

export default script